export default __webpack_public_path__ + "static/media/welcome.ad575600.png";